import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  action: {
    minWidth: 'unset !important',
    padding: 'unset !important',
    margin: '5px !important',
    '& svg': { width: '24px', height: '24px' },
  },
  actionDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed !important',
  },
  actionEnabled: {
    cursor: 'pointer',
  },
}));

export default useStyles;
